module.exports = __webpack_public_path__ + "img/1.99053c76.png";